<template>
  <div class="step-flow-footer d-flex flex-md-row flex-column align-items-md-center bg-light py-2 px-3 mt-3 rounded">
    <label class="flow-footer-label mb-md-0 mb-2 mr-md-3">Action</label>
    <div class="d-flex flex-md-row flex-column align-items-md-center flex-grow-1">
      <b-form-radio-group class="d-flex flex-nowrap mr-md-3 mb-md-0 mb-2" :checked="flowAction"
        @change="onModeChange">
        <b-form-radio value="next">Continue to next step</b-form-radio>
        <b-form-radio value="link" class="ml-3">Go to step</b-form-radio>
      </b-form-radio-group>
      <b-form-select class="flow-dest-select mr-2" size="sm" :disabled="flowAction !== 'link'"
        :class="destSelectClass" :options="destinationOptions" :value="flowTarget" @change="onTargetChange">
        <template #first>
          <b-form-select-option :value="null">— Choose a step —</b-form-select-option>
        </template>
      </b-form-select>
      <span v-if="flowAction === 'link'" class="flow-link-badge category-chip" :class="chipClass">{{ badgeText }}</span>
    </div>
    <b-button size="sm" class="flow-end-chip mt-md-0 mt-2" :variant="flowAction === 'end' ? 'danger' : 'outline-danger'"
      @click="onToggleEnd">
      <i class="fas fa-ban"></i> END
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'StepFlowFooter',
  props: {
    step: { type: Object, required: true },
    destinationOptions: { type: Array, required: true },
    issues: { type: Array, default: function () { return [] } }
  },
  computed: {
    flowAction () {
      // Legacy data may still have flowTarget === 'end' (from the since
      // removed "END Procedure" option in the Link-to dropdown). Normalize
      // it here defensively in case the source data wasn't migrated yet.
      if (this.step.flowTarget === 'end') {
        return 'end'
      }
      return this.step.flowAction || 'next'
    },
    flowTarget () {
      if (this.step.flowTarget === 'end') {
        return null
      }
      return this.step.flowTarget != null ? this.step.flowTarget : null
    },
    stepIssues () {
      var stepId = this.step.id
      return this.issues.filter(function (i) { return i.stepId === stepId && i.key === 'default' })
    },
    hasError () {
      return this.stepIssues.some(function (i) { return i.severity === 'error' })
    },
    hasWarning () {
      return this.stepIssues.some(function (i) { return i.severity === 'warning' })
    },
    destSelectClass () {
      if (this.flowAction !== 'link') {
        return ''
      }
      if (this.hasError) {
        return 'is-invalid border-danger'
      }
      if (this.hasWarning) {
        return 'border-warning'
      }
      return 'flow-dest-linked'
    },
    chipClass () {
      if (this.hasError) {
        return 'category-chip-danger'
      }
      if (this.hasWarning) {
        return 'category-chip-warning'
      }
      return 'category-chip-linked'
    },
    badgeText () {
      if (this.hasError) {
        return '⚠ Loop!'
      }
      if (this.hasWarning) {
        return '⚠ Unset'
      }
      return '✓ Linked'
    }
  },
  methods: {
    onModeChange (mode) {
      this.$emit('change', { flowAction: mode, flowTarget: mode === 'link' ? this.flowTarget : null })
    },
    onTargetChange (target) {
      this.$emit('change', { flowAction: 'link', flowTarget: target })
    },
    onToggleEnd () {
      var next = this.flowAction === 'end' ? 'next' : 'end'
      this.$emit('change', { flowAction: next, flowTarget: null })
    }
  }
}
</script>

<style scoped>
.step-flow-footer {
  border-top: 1px solid #e9ecef;
}
.flow-footer-label {
  font-size: .75em;
  font-weight: 700;
  text-transform: uppercase;
  color: #9a9a9a;
}
.flow-dest-select {
  max-width: 260px;
}
.flow-dest-linked {
  border-color: #00518d;
}
.flow-link-badge {
  font-weight: 600;
}
.category-chip {
  display: inline-block;
  border-radius: 0.5em;
  padding: .1em .6em;
  font-size: .75em;
  font-weight: 600;
  background-color: #f5f5f5;
  color: #666666;
}
.category-chip-linked {
  background-color: #e5f2ff;
  color: #00518d;
}
.category-chip-warning {
  background-color: #fdf3e0;
  color: #8c5429;
}
.category-chip-danger {
  background-color: #fae1e3;
  color: #89151c;
}
</style>
